import React from 'react';
import { File, Folder } from '../../types';

export interface DraggableItemProps {
  id: string;
  type: 'file' | 'folder';
  item: File | Folder;
  children: React.ReactNode;
  disableDrag?: boolean;
}

const DraggableItem: React.FC<DraggableItemProps> = ({
  id,
  type,
  item,
  children,
  disableDrag = false
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    if (disableDrag) return;
    
    e.dataTransfer.setData('application/json', JSON.stringify({
      id,
      type,
      item
    }));
    
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      draggable={!disableDrag}
      onDragStart={handleDragStart}
      style={{ cursor: disableDrag ? 'default' : 'move' }}
    >
      {children}
    </div>
  );
};

export default DraggableItem; 